import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    nav_expeditions: "Expéditions",
    nav_story: "Notre Histoire",
    nav_cercle: "Le Cercle",
    nav_contact: "Contact",
    nav_faq: "Sécurité",
    login: "Se connecter",
    logout: "Déconnexion",
    on_invite: "Sur invitation",
    hero_kicker: "Hors du réseau. Hors des sentiers.",
    hero_title: "Là où le réseau\ns'arrête.",
    hero_sub: "Des expéditions extrêmes, rares, tenues à l'écart. Sept jours, cinq places, aucun retour en arrière. Vous ne rapporterez pas des photos : vous rapporterez une histoire.",
    hero_cta: "Découvrir les expéditions",
    hero_cta2: "Rejoindre le Cercle",
    section_selected: "Sélection en cours",
    section_selected_sub: "Places limitées. Accès sur candidature.",
    view_all: "Voir tout le catalogue",
    manifesto_kicker: "Le manifeste",
    manifesto: "On ne vend pas des vacances. On ouvre des portes que personne d'autre ne peut ouvrir. Chaque expédition est brute, limitée à cinq personnes, et elle se mérite.",
    why_title: "Pourquoi HORS SIGNAL",
    why_sub: "Ce qui fait la différence, à chaque expédition.",
    why_1_t: "Partenaires locaux",
    why_1_d: "Chaque itinéraire est conçu avec des partenaires locaux de confiance, pour un accès unique et un impact positif sur place.",
    why_2_t: "Testé sur le terrain",
    why_2_d: "Chaque expédition est repérée et éprouvée sur le terrain avant d'être proposée. Rien n'est laissé au hasard.",
    why_3_t: "Aventure authentique",
    why_3_d: "Loin des circuits touristiques : des expériences brutes et rares, pensées pour marquer une vie entière.",
    why_4_t: "Très petits groupes",
    why_4_d: "Jusqu'à douze personnes maximum. Exclusivité, cohésion du groupe et sécurité avant tout.",
    all_expeditions: "Nos Expéditions",
    filter_region: "Région",
    filter_intensity: "Intensité",
    filter_duration: "Durée",
    filter_all: "Toutes",
    map_title: "Carte des terrains",
    map_sub: "Chaque point est une frontière.",
    days: "jours",
    from: "à partir de",
    intensity: "Intensité",
    risk: "Niveau de risque",
    spots_left: "places restantes",
    deadline: "Clôture des candidatures",
    included: "Ce qui est inclus",
    testimonials: "Récits",
    book: "Réserver ma place",
    book_deposit: "Verser l'acompte",
    request: "Faire une demande",
    reserve_title: "Réserver cette expédition",
    your_name: "Votre nom",
    your_email: "Email",
    your_phone: "Téléphone",
    participants: "Participants",
    message: "Message",
    send: "Envoyer",
    pay_deposit: "Payer l'acompte",
    story_title: "Notre Histoire",
    cercle_title: "Le Cercle HorsSignal",
    cercle_locked: "Espace réservé aux membres ayant vécu une expédition.",
    cercle_share: "Partager un récit",
    contact_title: "Contact & Candidature",
    faq_title: "Sécurité & Assurances",
    newsletter_title: "Accès prioritaire",
    newsletter_sub: "Recevez les nouvelles expéditions avant tout le monde. Aucune place n'attend.",
    final_cta_title: "Prêt à commencer l'aventure ?",
    final_cta_btn: "Trouve ton expédition",
    subscribed_ok: "Inscription confirmée ✓",
    subscribe_err: "Une erreur est survenue.",
    subscribe: "M'inscrire",
    email_placeholder: "votre@email.com",
    chat_title: "Concierge HorsSignal",
    chat_placeholder: "Posez votre question...",
    reg_title: "Rejoindre HorsSignal",
    login_title: "Accès membre",
    have_account: "Déjà membre ? Se connecter",
    no_account: "Pas encore membre ? Créer un compte",
    or_google: "Continuer avec Google",
    payment_success: "Acompte confirmé",
    payment_pending: "Vérification du paiement...",
    payment_failed: "Le paiement n'a pas abouti",
    back_home: "Retour à l'accueil",
    footer_tag: "Voyages extrêmes, rares et confidentiels.",
    cta_reserve: "Réserver ma place",
    cta_candidater: "Candidater",
    reassurance_title: "Encadré. Assuré. En confiance.",
    reassurance_sub: "Une prestation engageante mérite un cadre irréprochable.",
    reassurance_1_t: "Assurance incluse",
    reassurance_1_d: "Rapatriement et frais médicaux d'urgence adaptés aux zones reculées, sur chaque expédition.",
    reassurance_2_t: "Guides experts",
    reassurance_2_d: "Encadrement local aguerri, logistique éprouvée et contacts de terrain vérifiés.",
    reassurance_3_t: "Risque maîtrisé",
    reassurance_3_d: "Niveau de risque affiché, briefing de sécurité et préparation avant chaque départ.",
    stats_exp: "Expéditions au catalogue",
    stats_members: "Explorateurs maximum par groupe",
    stats_since: "Fondée en",
    social_proof_title: "Ils y sont allés",
    social_proof_sub: "Des récits, pas des cartes postales.",
    quick_contact: "Une question avant de vous engager ?",
    whatsapp: "Écrire sur WhatsApp",
    contact_us: "Nous contacter",
    legal_mentions: "Mentions légales",
    legal_cgv: "CGV",
    legal_privacy: "Confidentialité",
    legal_cookies: "Cookies",
    legal: "Légal",
    atout_france: "Immatriculation Atout France",
    cookie_text: "Nous utilisons des cookies pour améliorer votre expérience et mesurer l'audience.",
    cookie_accept: "Accepter",
    cookie_refuse: "Refuser",
    departure: "Prochain départ",
    available: "Places disponibles",
    waitlist: "Liste d'attente",
    nav_gallery: "Galerie",
    gallery_title: "Galerie",
    gallery_sub: "Les images réelles de nos expéditions passées. Aucune banque d'images.",
    gallery_soon: "Photos à venir — issues des prochaines expéditions réalisées.",
    founder_kicker: "Le fondateur",
    founder_title: "J'ai d'abord vécu le train avant de le raconter.",
    founder_name: "— Le fondateur, HorsSignal",
    founder_text: "En 2019, j'ai grimpé sur un wagon de minerai en Mauritanie, sans billet ni confort, pour traverser le Sahara une nuit entière. Ce que j'ai ressenti cette nuit-là n'existait dans aucun catalogue. HorsSignal est né de cette obsession : ouvrir à d'autres les portes que j'ai forcées moi-même, avec le sérieux et la sécurité que ces terrains exigent.",
    testimonials_soon_title: "Les premiers récits",
    testimonials_soon: "Les témoignages de nos explorateurs apparaîtront ici après les prochaines expéditions.",
    cookie_settings: "Réglages cookies",
    cookie_customize: "Personnaliser",
    cookie_necessary: "Strictement nécessaires",
    cookie_necessary_d: "Indispensables au fonctionnement du site. Toujours actifs.",
    cookie_analytics: "Mesure d'audience",
    cookie_analytics_d: "Nous aident à comprendre l'usage du site (anonyme).",
    cookie_save: "Enregistrer mes choix",
    globe_view: "Voir la fiche",
    globe_hint: "Glisser pour tourner · molette pour zoomer",
    cta_book: "Réserver",
    gate_title: "L'accès se mérite.",
    gate_sub: "Laissez votre email pour entrer et recevoir en avant-première nos prochaines expéditions.",
    gate_enter: "Entrer",
    gate_note: "Sur invitation · Places strictement limitées",
    fiche_expedition: "Fiche d'expédition",
    select_date: "Choisir une date de départ",
    choose_date: "Sélectionnez une date",
    group_max: "Groupe de 5 personnes maximum",
    d_excluded: "Non inclus",
    d_program: "Programme",
    d_gear: "Matériel requis",
    d_physical: "Conditions physiques",
    d_safety: "Risques & sécurité",
    d_important: "Informations importantes",
    d_day: "J",
    avail_last: "Dernières places",
    avail_full: "Complet",
    coming_soon_badge: "Coming Soon",
    coming_soon_places: "Bientôt disponible",
    preview_only: "Prévisualisation uniquement",
    preview_card: "Prévisualiser",
    reservations_soon: "Ouverture des réservations à venir · restez connectés",
    group_note: "Candidature étudiée sous 48H ouvrables",
    req_join: "Demander à rejoindre",
    req_title: "Demande de réservation",
    req_reassure1: "Remplissez le formulaire ci-dessous pour demander une place. Nous vous recontacterons sous 48 h.",
    req_country: "Pays",
    req_firstname: "Prénom",
    req_lastname: "Nom",
    req_phone: "Téléphone",
    req_whatsapp: "Ce numéro est joignable sur WhatsApp",
    req_motivation: "Parlez-nous de vous, de votre expérience et de vos motivations",
    req_promo: "Code promotionnel (optionnel)",
    req_apply: "Appliquer",
    req_applied: "appliquée",
    req_reassure2: "Nous sélectionnons nos participants afin de préserver la qualité et la cohésion des groupes.",
    consent_cgv_1: "J'ai lu et j'accepte les ",
    consent_cgv_name: "Conditions Générales de Vente",
    consent_privacy_1: "J'accepte la ",
    consent_privacy_name: "Politique de Confidentialité",
    consent_recontact_txt: "J'autorise HorsSignal à me recontacter au sujet de ma demande.",
    req_sending: "Envoi...",
    req_datefull: "Date complète",
    req_submit: "Envoyer ma demande",
    req_reassure3: "Notre équipe vous répond généralement sous 24 à 48 heures. Aucun paiement n'est demandé à ce stade — l'acompte de 30 % ne sera réglé qu'après validation de votre candidature.",
    reassure_payment: "Paiement uniquement après acceptation",
    reassure_response: "Réponse garantie sous 48 h",
    reassure_data: "Données sécurisées et confidentielles",
    toast_consents: "Merci d'accepter les trois conditions pour envoyer votre demande.",
    toast_sent: "Demande envoyée ✓ Vous allez recevoir un email de confirmation.",
    toast_send_err: "Erreur lors de l'envoi. Réessayez.",
    toast_code_applied: "Code appliqué :",
    toast_code_invalid: "Code invalide",
    toast_code_err: "Erreur de vérification",
    promo_welcome: "Offre de bienvenue",
    promo_first_order: "sur votre première commande",
    promo_ready_title: "Votre code est prêt",
    promo_ready_desc: "Nous venons de vous l'envoyer par email. Utilisez-le lors de votre demande de réservation.",
    promo_form_a: "Laissez votre email et recevez instantanément votre ",
    promo_form_strong: "code personnel",
    promo_form_b: " à utiliser lors de votre première demande de réservation.",
    promo_firstname: "Prénom",
    promo_email: "Email",
    promo_get_code: "Recevoir mon code",
    promo_close: "Fermer",
    promo_toast_sent: "Code envoyé par email ✓",
    promo_toast_copied: "Code copié",
    promo_invalid_email: "Adresse email invalide (ex : nom@domaine.com).",
    promo_error: "Une erreur est survenue.",
    coord_section_title: "Coordinateur(s) de cette expédition",
    coord_guide_since: "Guide depuis",
  },
  en: {
    nav_expeditions: "Expeditions",
    nav_story: "Our Story",
    nav_cercle: "The Circle",
    nav_contact: "Contact",
    nav_faq: "Safety",
    login: "Sign in",
    logout: "Log out",
    on_invite: "By invitation",
    hero_kicker: "Off the grid. Off the track.",
    hero_title: "Where the signal\nends.",
    hero_sub: "Extreme, rare, deliberately hidden expeditions. Seven days, five spots, no turning back. You won't bring home photos: you'll bring home a story.",
    hero_cta: "Explore expeditions",
    hero_cta2: "Join the Circle",
    section_selected: "Currently selected",
    section_selected_sub: "Limited spots. Access by application.",
    view_all: "View full catalogue",
    manifesto_kicker: "The manifesto",
    manifesto: "We don't sell holidays. We open doors no one else can open. Every expedition is raw, limited to five people, and it must be earned.",
    why_title: "Why HORS SIGNAL",
    why_sub: "What makes the difference, on every expedition.",
    why_1_t: "Local partners",
    why_1_d: "Every route is built with trusted local partners, for unique access and a positive impact on the ground.",
    why_2_t: "Field-tested",
    why_2_d: "Every expedition is scouted and proven on the ground before we offer it. Nothing is left to chance.",
    why_3_t: "Authentic adventure",
    why_3_d: "Far from tourist trails: raw, rare experiences designed to mark a lifetime.",
    why_4_t: "Very small groups",
    why_4_d: "Up to twelve people maximum. Exclusivity, group cohesion and safety above all.",
    all_expeditions: "Our Expeditions",
    filter_region: "Region",
    filter_intensity: "Intensity",
    filter_duration: "Duration",
    filter_all: "All",
    map_title: "Map of terrains",
    map_sub: "Each point is a frontier.",
    days: "days",
    from: "from",
    intensity: "Intensity",
    risk: "Risk level",
    spots_left: "spots left",
    deadline: "Applications close in",
    included: "What's included",
    testimonials: "Stories",
    book: "Book my spot",
    book_deposit: "Pay the deposit",
    request: "Send a request",
    reserve_title: "Reserve this expedition",
    your_name: "Your name",
    your_email: "Email",
    your_phone: "Phone",
    participants: "Participants",
    message: "Message",
    send: "Send",
    pay_deposit: "Pay deposit",
    story_title: "Our Story",
    cercle_title: "The HorsSignal Circle",
    cercle_locked: "Reserved for members who have lived an expedition.",
    cercle_share: "Share a story",
    contact_title: "Contact & Application",
    faq_title: "Safety & Insurance",
    newsletter_title: "Priority access",
    newsletter_sub: "Get new expeditions before anyone else. No spot waits.",
    final_cta_title: "Ready to start the adventure?",
    final_cta_btn: "Find your expedition",
    subscribed_ok: "Subscribed ✓",
    subscribe_err: "An error occurred.",
    subscribe: "Subscribe",
    email_placeholder: "your@email.com",
    chat_title: "HorsSignal Concierge",
    chat_placeholder: "Ask your question...",
    reg_title: "Join HorsSignal",
    login_title: "Member access",
    have_account: "Already a member? Sign in",
    no_account: "Not a member yet? Create account",
    or_google: "Continue with Google",
    payment_success: "Deposit confirmed",
    payment_pending: "Verifying payment...",
    payment_failed: "Payment did not complete",
    back_home: "Back home",
    footer_tag: "Extreme, rare and confidential journeys.",
    cta_reserve: "Book my spot",
    cta_candidater: "Apply",
    reassurance_title: "Guided. Insured. In confidence.",
    reassurance_sub: "A committing experience deserves a flawless framework.",
    reassurance_1_t: "Insurance included",
    reassurance_1_d: "Repatriation and emergency medical cover suited to remote areas, on every expedition.",
    reassurance_2_t: "Expert guides",
    reassurance_2_d: "Seasoned local guiding, proven logistics and verified field contacts.",
    reassurance_3_t: "Managed risk",
    reassurance_3_d: "Displayed risk level, safety briefing and preparation before every departure.",
    stats_exp: "Expeditions in catalogue",
    stats_members: "Max explorers per group",
    stats_since: "Founded in",
    social_proof_title: "They went there",
    social_proof_sub: "Stories, not postcards.",
    quick_contact: "A question before you commit?",
    whatsapp: "Message on WhatsApp",
    contact_us: "Contact us",
    legal_mentions: "Legal notice",
    legal_cgv: "Terms",
    legal_privacy: "Privacy",
    legal_cookies: "Cookies",
    legal: "Legal",
    atout_france: "Atout France registration",
    cookie_text: "We use cookies to improve your experience and measure audience.",
    cookie_accept: "Accept",
    cookie_refuse: "Decline",
    departure: "Next departure",
    available: "Spots available",
    waitlist: "Waiting list",
    nav_gallery: "Gallery",
    gallery_title: "Gallery",
    gallery_sub: "Real images from our past expeditions. No stock photos.",
    gallery_soon: "Photos coming soon — from upcoming completed expeditions.",
    founder_kicker: "The founder",
    founder_title: "I lived the train before telling its story.",
    founder_name: "— The founder, HorsSignal",
    founder_text: "In 2019 I climbed onto an iron-ore wagon in Mauritania, no ticket, no comfort, to cross the Sahara through an entire night. What I felt that night existed in no catalogue. HorsSignal was born from that obsession: to open for others the doors I forced myself, with the rigour and safety these terrains demand.",
    testimonials_soon_title: "The first stories",
    testimonials_soon: "Our explorers' testimonials will appear here after the upcoming expeditions.",
    cookie_settings: "Cookie settings",
    cookie_customize: "Customise",
    cookie_necessary: "Strictly necessary",
    cookie_necessary_d: "Essential for the site to work. Always on.",
    cookie_analytics: "Audience measurement",
    cookie_analytics_d: "Help us understand site usage (anonymous).",
    cookie_save: "Save my choices",
    globe_view: "View expedition",
    globe_hint: "Drag to rotate · scroll to zoom",
    cta_book: "Book now",
    gate_title: "Access is earned.",
    gate_sub: "Leave your email to enter and get early access to our next expeditions.",
    gate_enter: "Enter",
    gate_note: "By invitation · Strictly limited spots",
    fiche_expedition: "Expedition sheet",
    select_date: "Choose a departure date",
    choose_date: "Select a date",
    group_max: "Groups of 5 people maximum",
    d_excluded: "Not included",
    d_program: "Itinerary",
    d_gear: "Required gear",
    d_physical: "Physical requirements",
    d_safety: "Risks & safety",
    d_important: "Important information",
    d_day: "D",
    avail_last: "Last spots",
    avail_full: "Full",
    coming_soon_badge: "Coming Soon",
    coming_soon_places: "Coming soon",
    preview_only: "Preview only",
    preview_card: "Preview",
    reservations_soon: "Bookings opening soon · stay tuned",
    group_note: "Application reviewed within 48 business hours",
    req_join: "Request to join",
    req_title: "Booking request",
    req_reassure1: "Fill in the form below to request a spot. We'll get back to you within 48 h.",
    req_country: "Country",
    req_firstname: "First name",
    req_lastname: "Last name",
    req_phone: "Phone",
    req_whatsapp: "This number is reachable on WhatsApp",
    req_motivation: "Tell us about yourself, your experience and your motivations",
    req_promo: "Promo code (optional)",
    req_apply: "Apply",
    req_applied: "applied",
    req_reassure2: "We select our participants to preserve the quality and cohesion of our groups.",
    consent_cgv_1: "I have read and accept the ",
    consent_cgv_name: "Terms & Conditions",
    consent_privacy_1: "I accept the ",
    consent_privacy_name: "Privacy Policy",
    consent_recontact_txt: "I authorise HorsSignal to contact me about my request.",
    req_sending: "Sending...",
    req_datefull: "Date full",
    req_submit: "Send my request",
    req_reassure3: "Our team usually replies within 24 to 48 hours. No payment is requested at this stage — the 30% deposit is only paid after your application is approved.",
    reassure_payment: "Payment only after acceptance",
    reassure_response: "Guaranteed reply within 48 h",
    reassure_data: "Secure & confidential data",
    toast_consents: "Please accept the three conditions to send your request.",
    toast_sent: "Request sent ✓ You'll receive a confirmation email.",
    toast_send_err: "Error while sending. Please try again.",
    toast_code_applied: "Code applied:",
    toast_code_invalid: "Invalid code",
    toast_code_err: "Verification error",
    promo_welcome: "Welcome offer",
    promo_first_order: "on your first booking",
    promo_ready_title: "Your code is ready",
    promo_ready_desc: "We've just emailed it to you. Use it when you make your booking request.",
    promo_form_a: "Leave your email and instantly receive your ",
    promo_form_strong: "personal code",
    promo_form_b: " to use on your first booking request.",
    promo_firstname: "First name",
    promo_email: "Email",
    promo_get_code: "Get my code",
    promo_close: "Close",
    promo_toast_sent: "Code sent by email ✓",
    promo_toast_copied: "Code copied",
    promo_invalid_email: "Invalid email address (e.g. name@domain.com).",
    promo_error: "An error occurred.",
    coord_section_title: "Your expedition coordinator(s)",
    coord_guide_since: "Guiding since",
  },
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("hs_lang") || "fr");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const toggle = () => {
    const next = lang === "fr" ? "en" : "fr";
    setLang(next);
    localStorage.setItem("hs_lang", next);
  };
  const t = (key) => dict[lang][key] || key;
  const L = (obj) => {
    if (Array.isArray(obj)) return obj;
    return obj && typeof obj === "object" ? obj[lang] || obj.fr : obj;
  };
  return <I18nContext.Provider value={{ lang, toggle, t, L }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
